import React from 'react';

import { Button } from '@mui/material';
import PropTypes from 'prop-types';

import { formsTestIds } from '../../../../forms.testIds';

const SignatureDialogActions = ({ isSaveUnavailable = false, isSaveDisabled, onCancel }) => (
  <div className="flex justify-end items-center gap-12">
    <Button
      data-testid={formsTestIds.SIGNATURE_CANCEL_BUTTON}
      type="button"
      variant={isSaveUnavailable ? 'contained' : 'outlined'}
      onClick={onCancel}
    >
      {isSaveUnavailable ? 'Close' : 'Cancel'}
    </Button>
    {!isSaveUnavailable && (
      <Button
        data-testid={formsTestIds.SIGNATURE_SAVE_BUTTON}
        disabled={isSaveDisabled}
        type="submit"
        variant="contained"
      >
        Save
      </Button>
    )}
  </div>
);

SignatureDialogActions.propTypes = {
  isSaveDisabled: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  isSaveUnavailable: PropTypes.bool,
};

export default SignatureDialogActions;
